import React, { useMemo } from 'react';
import AdminDashboardImageWidget from './AdminDashboardImageWidget';
import { adminDashboardWidgetPreviews } from './adminDashboardWidgetPreviewData';
import useAdminAccess from '../../../Hooks/useAdminAccess';
import { AdminSupportingText } from '../shared/adminUx';

export default function AdminDashboardWidgetPreviews() {
  const { getVisibleDashboardWidgets } = useAdminAccess();

  const visibleWidgets = useMemo(
    () => getVisibleDashboardWidgets(adminDashboardWidgetPreviews),
    [getVisibleDashboardWidgets],
  );

  return (
    <div className="pb-10">
      {visibleWidgets.length ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          {visibleWidgets.map((widget) => (
            <AdminDashboardImageWidget
              key={widget.id}
              title={widget.title}
              image={widget.image}
            />
          ))}
        </div>
      ) : (
        <AdminSupportingText className="text-mediumgray">
          No dashboard widgets are available for this role.
        </AdminSupportingText>
      )}
    </div>
  );
}
